module.exports = __webpack_public_path__ + "static/img/referral-img.76a73ae.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/referral-img.png
// module id = le+b
// module chunks = 1